<template>
  <div class="main">
    <!-- 国家税务总局电子税务局登录 -->
    <div class="main-wrapper">
      <loginMain @loginSuccess="login" />
    </div>
  </div>
</template>

<script setup name="StateTax/login">
import loginMain from "../cmp/loginMain.vue";
import {setLoginInfo} from "@/views/digitalInvoice/digitalLoginHandler.js";

const emits = defineEmits(["changePage"]);

//点击登录按钮跳转至套餐业务页面
const login = async () => {
  setLoginInfo()
  emits("changePage", "package");
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  .main-wrapper {
    width: 100%;
    height: 100%;
    background: #000 url("https://static.rhkj.com/renhe_fe/other/stateTax/login_bg.png") no-repeat top / 100% 100%;
    display: grid;
    place-content: center;
  }
}
</style>
